import { render, staticRenderFns } from "./Warn.vue?vue&type=template&id=9876e7c2&scoped=true&"
import script from "./Warn.vue?vue&type=script&lang=js&"
export * from "./Warn.vue?vue&type=script&lang=js&"
import style0 from "./Warn.vue?vue&type=style&index=0&id=9876e7c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9876e7c2",
  null
  
)

export default component.exports